module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"validationThreshold":{"message":"The threshold value must be between a minimum of {minTh} and a maximum of {maxTh} mm"}},"it":{"validationThreshold":{"message":"Il valore di soglia deve essere compreso tra un minimo di {minTh} e un massimo di {maxTh} mm"}}}')
  delete Component.options._Ctor
}
